import ValueSelectField from './component'

export default ValueSelectField
